import { render, staticRenderFns } from "./FormErrors.vue?vue&type=template&id=360965c7&"
import script from "./FormErrors.vue?vue&type=script&lang=js&"
export * from "./FormErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports